module.exports = __webpack_public_path__ + "img/wild.ac6acafe.png";